export default function TitleComponent(title) {
  if (typeof title !== "string") {
    throw new Error("Title should be an string");
  }
  document.title = `${title}::Streamline ERP Control Panel`;
}
